import apiClient from "Configuration/apiClient";
import API_CONFIG from "Configuration/apiConfig";

export const generateReport = (file, { onUploadProgress, onDownloadProgress } = {}) => {
  const formData = new FormData();
  formData.append("file", file);

  return apiClient.post(API_CONFIG.ENDPOINTS.REPORTS.GENERATE, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob",
    onUploadProgress,
    onDownloadProgress,
  });
};

export const extractFilenameFromHeaders = (headers, fallbackName) => {
  const disposition = headers?.["content-disposition"] || headers?.["Content-Disposition"];
  if (disposition) {
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      try { return decodeURIComponent(utf8Match[1]); } catch { /* fall through */ }
    }
    const quotedMatch = disposition.match(/filename="?([^";]+)"?/i);
    if (quotedMatch?.[1]) return quotedMatch[1].trim();
  }
  return fallbackName;
};